import { render, staticRenderFns } from "./2-1-escenario2.vue?vue&type=template&id=12d6e239&scoped=true&lang=pug&"
import script from "./2-1-escenario2.vue?vue&type=script&lang=js&"
export * from "./2-1-escenario2.vue?vue&type=script&lang=js&"
import style0 from "./2-1-escenario2.vue?vue&type=style&index=0&id=12d6e239&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6e239",
  null
  
)

export default component.exports